<template>
  <app-client-simple-layout title="パスワードリセット">
    <div class="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div class="w-full max-w-md bg-white shadow-lg rounded-lg p-8">
        <h1 class="text-xl font-bold text-center mb-6">パスワードリセット</h1>

        <div v-if="!isSend">
          <form @submit.prevent="resetPassword">
            <label for="email">
              メールアドレス
            </label>
            <input
              v-model="email"
              class="block mt-2 mb-2 w-full border-1 border-gray-500 rounded"
              type="email"
              required
              placeholder="メールアドレス"
              autocomplete="email" />
            <div
              v-if="resetPasswordFormErrorText"
              class="text-red-500 mb-5">
              ※{{ resetPasswordFormErrorText }}
            </div>
            <button
              :disabled="isProcessing"
              class="flex justify-self-end text-white text-center text-base bg-CLIENT_PRIMARY_PINK rounded-xl
                  mx-auto mt-2 px-10 py-2 hover:bg-CLIENT_PRIMARY_PINK_HOVER duration-500 disabled:bg-gray-300
                  disabled:cursor-not-allowed">
              再設定用メールを送信
            </button>
          </form>
        </div>

        <div
          v-else
          class="text-center py-8">
          <p class="mb-4">パスワード再設定用のメールを送信しました。</p>
          <p class="text-sm text-gray-600">ご指定いただいたメールアドレスに再設定用のメールを送信しました。</p>
        </div>

        <div class="mt-6 text-center space-y-3">
          <a
            :href="route('clients.login.index')"
            class="block text-blue-500 underline hover:underline">
            ログインはこちら
          </a>
          <a
            :href="publicPortalUrl"
            class="block text-gray-500 underline hover:underline text-sm">
            トップページに戻る
          </a>
        </div>
      </div>
    </div>
  </app-client-simple-layout>
</template>

<script setup>
import { ref } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import {
  getAuth,
  sendPasswordResetEmail,
} from 'firebase/auth'
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'
import firebaseApp from '@/Constants/configFirebase'
import { EmailRegex } from '@/Constants/regularExpression'

const auth = getAuth(firebaseApp)
const publicPortalUrl = usePage().props.value.portal.publicUrl
const email = ref('')
const resetPasswordFormErrorText = ref('')
const isProcessing = ref(false)
const isSend = ref(false)

const actionCodeSettings = {
  url: route('clients.login.index'),
}

const resetPassword = () => {
  if (!email.value.match(EmailRegex)) {
    resetPasswordFormErrorText.value = '登録されているメールアドレスを正しく入力してください。'
    return false
  }
  resetPasswordFormErrorText.value = ''

  // 多重ポストを避ける
  if (isProcessing.value) return false
  isProcessing.value = true

  sendPasswordResetEmail(auth, email.value, actionCodeSettings)
    .then(() => {
      isProcessing.value = false
      isSend.value = true
    })
    .catch((e) => {
      isProcessing.value = false
      resetPasswordFormErrorText.value = 'メールの送信に失敗しました。入力内容をご確認ください。'
      return false
    })
  return undefined
}
</script>
